import store from "@packages/store";
import Vue from "vue";

export default {
    async find(id) {
        return await Vue.api.devices.find({ id });
    },

    async getDevices() {
        const establishmentId = store.state.users.user.id;
        const devices = await Vue.api.devices.getDevices({ establishmentId });

        store.commit("SET_DEVICES", devices);

        return devices;
    },

    async load({ pagination, filters }) {
        const devices = await Vue.api.locals.load({ pagination, filters });

        store.commit("SET_DEVICES_LIST", devices);
        store.commit("SET_DEVICES", devices);

        return devices;
    },

    async count({ filters }) {
        const count = await Vue.api.devices.count({ filters });

        store.commit("SET_DEVICES_COUNT", count);

        return count;
    },

    async getAccountTotalDevicesNumber() {
        const count = await Vue.api.core.account.getAccountTotalDevicesNumber();

        store.commit("DEVICES_SET_COUNT", count);

        return count;
    }
};
